import { useState } from 'react';
import { Card, Title, Text, Box, Link, Icon } from '@nimbus-ds/components';
import { PlusCircleIcon } from '@nimbus-ds/icons';
import { useModal } from 'commons/hooks';
import { useTranslationAccount } from 'domains/Account/hooks';
import { GeneralTax, ExceptionsTable, TaxExceptionsModal } from './components';

function TaxExceptionsCard() {
  const t = useTranslationAccount('businessDataPage.taxesWithExceptions');
  const [checked, setChecked] = useState(true);
  const [isShowModal, openModal, closeModal] = useModal();

  // TODO: get taxRate from API
  const taxRate = 21;

  const onCheckChange = (checked: boolean) => {
    setChecked(checked);
  };
  return (
    <Card>
      <Card.Header>
        <Title as="h4">{t('title')}</Title>
      </Card.Header>
      <Card.Body>
        <Box display="flex" flexDirection="column" gap="3">
          <GeneralTax
            checked={checked}
            taxRate={taxRate}
            onCheckChange={onCheckChange}
          />
          <Box display="flex" flexDirection="column" gap="2">
            <Text fontWeight="bold">{t('subtitle')}</Text>
            <Text>{t('description')}</Text>
          </Box>
          <Link
            appearance="primary"
            as="button"
            textDecoration="none"
            onClick={openModal}
          >
            <Icon color="currentColor" source={<PlusCircleIcon />} />
            {t('addExceptions')}
          </Link>
          <ExceptionsTable />
          {isShowModal && (
            <TaxExceptionsModal onClose={closeModal} isOpen={isShowModal} />
          )}
        </Box>
      </Card.Body>
    </Card>
  );
}

export default TaxExceptionsCard;
